import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageHeader from '../../components/PageHeader';
import { apiCall } from '../../helpers/MainHelper';
import { toast } from 'react-toastify';
import ReactLoading from 'react-loading';
import './CampaignManagement.css';

class CampaignManagement extends Component {
  state = {
    campaigns: [],
    services: [],
    loading: true,
    showModal: false,
    modalType: '', // 'create' or 'update'
    selectedCampaign: null,
    formData: {
      title: '',
      subtitle: '',
      description: '',
      image: null,
      imagePreview: null,
      service_id: '',
      link: '',
      type: 'general',
      status: 'ACTIVE',
      display_order: 0,
      start_date: '',
      end_date: '',
    },
    processingAction: false,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.fetchCampaigns();
    this.fetchServices();
  }

  fetchCampaigns = async () => {
    try {
      this.setState({ loading: true });
      const response = await apiCall('business/campaign-management/all', 'get');

      if (response.status === 'success') {
        this.setState({ campaigns: response.data, loading: false });
      } else {
        toast.error('Kampanyalar yüklenemedi');
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error('Error fetching campaigns:', error);
      toast.error('Bir hata oluştu: ' + (error.response?.data?.message || error.message));
      this.setState({ loading: false });
    }
  };

  fetchServices = async () => {
    try {
      const response = await apiCall('business/campaign-management/services', 'get');
      if (response.status === 'success') {
        this.setState({ services: response.data });
      }
    } catch (error) {
      console.error('Error fetching services:', error);
    }
  };

  handleOpenCreateModal = () => {
    this.setState({
      showModal: true,
      modalType: 'create',
      selectedCampaign: null,
      formData: {
        title: '',
        subtitle: '',
        description: '',
        image: null,
        imagePreview: null,
        service_id: '',
        link: '',
        type: 'general',
        status: 'ACTIVE',
        display_order: 0,
        start_date: '',
        end_date: '',
      },
    });
  };

  handleOpenUpdateModal = (campaign) => {
    this.setState({
      showModal: true,
      modalType: 'update',
      selectedCampaign: campaign,
      formData: {
        title: campaign.title,
        subtitle: campaign.subtitle || '',
        description: campaign.description || '',
        image: null,
        imagePreview: campaign.image_url || null,
        service_id: campaign.service_id || '',
        link: campaign.link || '',
        type: campaign.type,
        status: campaign.status,
        display_order: campaign.display_order,
        start_date: campaign.start_date ? campaign.start_date.split('T')[0] : '',
        end_date: campaign.end_date ? campaign.end_date.split('T')[0] : '',
      },
    });
  };

  handleCloseModal = () => {
    this.setState({
      showModal: false,
      modalType: '',
      selectedCampaign: null,
      formData: {
        title: '',
        subtitle: '',
        description: '',
        image: null,
        imagePreview: null,
        service_id: '',
        link: '',
        type: 'general',
        status: 'ACTIVE',
        display_order: 0,
        start_date: '',
        end_date: '',
      },
    });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      formData: {
        ...this.state.formData,
        [name]: value,
      },
    });
  };

  handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.setState({
          formData: {
            ...this.state.formData,
            image: file,
            imagePreview: reader.result,
          },
        });
      };
      reader.readAsDataURL(file);
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { modalType, formData } = this.state;

    this.setState({ processingAction: true });

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('title', formData.title);
      formDataToSend.append('subtitle', formData.subtitle);
      formDataToSend.append('description', formData.description);
      if (formData.image) {
        formDataToSend.append('image', formData.image);
      }
      if (formData.service_id) {
        formDataToSend.append('service_id', formData.service_id);
      }
      if (formData.link) {
        formDataToSend.append('link', formData.link);
      }
      formDataToSend.append('type', formData.type);
      formDataToSend.append('status', formData.status);
      formDataToSend.append('display_order', formData.display_order);
      if (formData.start_date) {
        formDataToSend.append('start_date', formData.start_date);
      }
      if (formData.end_date) {
        formDataToSend.append('end_date', formData.end_date);
      }

      const endpoint = modalType === 'create'
        ? 'business/campaign-management/create'
        : `business/campaign-management/update/${this.state.selectedCampaign.id}`;

      // For FormData, axios automatically sets Content-Type to multipart/form-data
      const response = await apiCall(endpoint, 'post', formDataToSend);

      if (response.status === 'success') {
        toast.success(response.message);
        this.handleCloseModal();
        this.fetchCampaigns();
      } else {
        toast.error(response.message || 'İşlem başarısız');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Bir hata oluştu: ' + (error.response?.data?.message || error.message));
    } finally {
      this.setState({ processingAction: false });
    }
  };

  handleToggleStatus = async (campaign) => {
    try {
      const response = await apiCall(`business/campaign-management/toggle-status/${campaign.id}`, 'post');

      if (response.status === 'success') {
        toast.success('Kampanya durumu güncellendi');
        this.fetchCampaigns();
      } else {
        toast.error(response.message || 'İşlem başarısız');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Bir hata oluştu: ' + (error.response?.data?.message || error.message));
    }
  };

  handleDelete = async (campaign) => {
    if (!window.confirm('Bu kampanyayı silmek istediğinize emin misiniz?')) {
      return;
    }

    try {
      const response = await apiCall(`business/campaign-management/delete/${campaign.id}`, 'delete');

      if (response.status === 'success') {
        toast.success('Kampanya başarıyla silindi');
        this.fetchCampaigns();
      } else {
        toast.error(response.message || 'İşlem başarısız');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Bir hata oluştu: ' + (error.response?.data?.message || error.message));
    }
  };

  render() {
    const { campaigns, services, loading, showModal, modalType, formData, processingAction } = this.state;

    return (
      <div
        className="admin-campaign-management"
        onClick={() => {
          document.body.classList.remove('offcanvas-active');
        }}
      >
        <div className="page-loader-wrapper" style={{ display: loading ? 'block' : 'none' }}>
          <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className="m-t-30">
              <img src={require('../../assets/images/logo-white.png')} width="150" alt="ServiceZone" />
            </div>
            <p>Yükleniyor</p>
            <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
          </div>
        </div>

        <div className="container-fluid">
          <PageHeader
            HeaderText="Kampanya Yönetimi"
            Breadcrumb={[
              { name: 'Admin', navigate: '' },
              { name: 'Kampanyalar', navigate: '' },
            ]}
          />

          {/* Stats Overview */}
          <div className="row clearfix mb-4">
            <div className="col-lg-4 col-md-6">
              <div className="stats-card">
                <div className="stats-icon campaigns">
                  <i className="fa fa-bullhorn"></i>
                </div>
                <div className="stats-content">
                  <h3>{campaigns.length}</h3>
                  <p>Toplam Kampanya</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="stats-card">
                <div className="stats-icon active">
                  <i className="fa fa-check-circle"></i>
                </div>
                <div className="stats-content">
                  <h3>
                    {campaigns.filter((c) => c.status === 'ACTIVE').length}
                  </h3>
                  <p>Aktif Kampanya</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="stats-card">
                <div className="stats-icon inactive">
                  <i className="fa fa-pause-circle"></i>
                </div>
                <div className="stats-content">
                  <h3>
                    {campaigns.filter((c) => c.status === 'INACTIVE').length}
                  </h3>
                  <p>Pasif Kampanya</p>
                </div>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="row clearfix mb-4">
            <div className="col-lg-12">
              <button
                className="btn btn-add-campaign"
                onClick={this.handleOpenCreateModal}
              >
                <i className="fa fa-plus"></i> Yeni Kampanya Ekle
              </button>
            </div>
          </div>

          {/* Campaigns List */}
          <div className="row clearfix">
            {campaigns.length === 0 ? (
              <div className="col-lg-12">
                <div className="empty-state">
                  <i className="fa fa-bullhorn"></i>
                  <p>Henüz kampanya eklenmemiş</p>
                  <button
                    className="btn btn-primary"
                    onClick={this.handleOpenCreateModal}
                  >
                    İlk Kampanyayı Ekle
                  </button>
                </div>
              </div>
            ) : (
              campaigns.map((campaign) => (
                <div key={campaign.id} className="col-lg-4 col-md-6 mb-4">
                  <div className="campaign-card">
                    <div className="campaign-image-container">
                      {campaign.image_url ? (
                        <img src={campaign.image_url} alt={campaign.title} className="campaign-image" />
                      ) : (
                        <div className="campaign-image-placeholder">
                          <i className="fa fa-image"></i>
                        </div>
                      )}
                      <span className={`campaign-status-badge ${campaign.status?.toLowerCase()}`}>
                        {campaign.status === 'ACTIVE' ? 'Aktif' : 'Pasif'}
                      </span>
                    </div>
                    <div className="campaign-content">
                      <h3 className="campaign-title">{campaign.title}</h3>
                      {campaign.subtitle && (
                        <p className="campaign-subtitle">{campaign.subtitle}</p>
                      )}
                      <div className="campaign-meta">
                        <span className={`campaign-type-badge ${campaign.type}`}>
                          {campaign.type === 'service' ? 'Servis' : campaign.type === 'external' ? 'Harici Link' : 'Genel'}
                        </span>
                        {campaign.service && (
                          <span className="campaign-service">{campaign.service.name}</span>
                        )}
                      </div>
                      <div className="campaign-actions">
                        <button
                          className="btn-action edit"
                          onClick={() => this.handleOpenUpdateModal(campaign)}
                          title="Düzenle"
                        >
                          <i className="fa fa-edit"></i>
                        </button>
                        <button
                          className={`btn-action toggle ${campaign.status === 'ACTIVE' ? 'deactivate' : 'activate'}`}
                          onClick={() => this.handleToggleStatus(campaign)}
                          title={campaign.status === 'ACTIVE' ? 'Pasifleştir' : 'Aktifleştir'}
                        >
                          <i className={`fa fa-${campaign.status === 'ACTIVE' ? 'toggle-on' : 'toggle-off'}`}></i>
                        </button>
                        <button
                          className="btn-action delete"
                          onClick={() => this.handleDelete(campaign)}
                          title="Sil"
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Modal for Create/Update Campaign */}
        {showModal && (
          <div className="modal-overlay" onClick={this.handleCloseModal}>
            <div className="campaign-modal" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={this.handleCloseModal}>
                ×
              </button>

              <h2 className="modal-title">
                {modalType === 'create' ? 'Yeni Kampanya Ekle' : 'Kampanyayı Güncelle'}
              </h2>

              <form onSubmit={this.handleSubmit} className="campaign-form">
                <div className="form-group">
                  <label>Kampanya Görseli *</label>
                  <div className="image-upload-container">
                    {formData.imagePreview ? (
                      <div className="image-preview">
                        <img src={formData.imagePreview} alt="Preview" />
                        <button
                          type="button"
                          className="remove-image"
                          onClick={() => {
                            this.setState({
                              formData: {
                                ...this.state.formData,
                                image: null,
                                imagePreview: null,
                              },
                            });
                          }}
                        >
                          <i className="fa fa-times"></i>
                        </button>
                      </div>
                    ) : (
                      <label className="image-upload-label">
                        <input
                          type="file"
                          accept="image/*"
                          onChange={this.handleImageChange}
                          required={modalType === 'create'}
                        />
                        <div className="image-upload-placeholder">
                          <i className="fa fa-cloud-upload"></i>
                          <p>Görsel Yükle</p>
                        </div>
                      </label>
                    )}
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Başlık *</label>
                    <input
                      type="text"
                      name="title"
                      value={formData.title}
                      onChange={this.handleInputChange}
                      placeholder="Kampanya başlığı"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Alt Başlık</label>
                    <input
                      type="text"
                      name="subtitle"
                      value={formData.subtitle}
                      onChange={this.handleInputChange}
                      placeholder="Kampanya alt başlığı"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Açıklama</label>
                  <textarea
                    name="description"
                    value={formData.description}
                    onChange={this.handleInputChange}
                    placeholder="Kampanya açıklaması"
                    rows="4"
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Kampanya Tipi *</label>
                    <select
                      name="type"
                      value={formData.type}
                      onChange={this.handleInputChange}
                      required
                    >
                      <option value="general">Genel</option>
                      <option value="service">Servis</option>
                      <option value="external">Harici Link</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Durum *</label>
                    <select
                      name="status"
                      value={formData.status}
                      onChange={this.handleInputChange}
                      required
                    >
                      <option value="ACTIVE">Aktif</option>
                      <option value="INACTIVE">Pasif</option>
                    </select>
                  </div>
                </div>

                {formData.type === 'service' && (
                  <div className="form-group">
                    <label>Servis</label>
                    <select
                      name="service_id"
                      value={formData.service_id}
                      onChange={this.handleInputChange}
                    >
                      <option value="">Servis Seçin</option>
                      {services.map((service) => (
                        <option key={service.id} value={service.id}>
                          {service.name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {formData.type === 'external' && (
                  <div className="form-group">
                    <label>Harici Link</label>
                    <input
                      type="url"
                      name="link"
                      value={formData.link}
                      onChange={this.handleInputChange}
                      placeholder="https://example.com"
                    />
                  </div>
                )}

                <div className="form-row">
                  <div className="form-group">
                    <label>Görüntülenme Sırası</label>
                    <input
                      type="number"
                      name="display_order"
                      value={formData.display_order}
                      onChange={this.handleInputChange}
                      min="0"
                    />
                  </div>

                  <div className="form-group">
                    <label>Başlangıç Tarihi</label>
                    <input
                      type="date"
                      name="start_date"
                      value={formData.start_date}
                      onChange={this.handleInputChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Bitiş Tarihi</label>
                    <input
                      type="date"
                      name="end_date"
                      value={formData.end_date}
                      onChange={this.handleInputChange}
                      min={formData.start_date}
                    />
                  </div>
                </div>

                <div className="modal-actions">
                  <button type="button" className="btn btn-cancel" onClick={this.handleCloseModal}>
                    İptal
                  </button>
                  <button type="submit" className="btn btn-submit" disabled={processingAction}>
                    {processingAction ? (
                      <>
                        <ReactLoading type="spin" color="#fff" width={20} height={20} />
                        <span>İşleniyor...</span>
                      </>
                    ) : (
                      <>
                        <i className="fa fa-save"></i>
                        {modalType === 'create' ? 'Kampanya Oluştur' : 'Kampanyayı Güncelle'}
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(CampaignManagement);

